export default __webpack_public_path__ + "static/media/about-us-banner-m-ms.136effa5.webp";